export const tableThemeToTailwindClasses = (theme: any) => {
    const classes = theme?.tailwindClasses || [];

    if (theme.isStriped) {
        classes.push(
            "[&>tbody>tr:nth-of-type(odd)]:bg-[var(--bg-light-color)]",
        );
        classes.push(
            "[&>tbody>tr:nth-of-type(even)]:bg-[var(--bg-dark-color)]",
        );
    }

    if (theme.isBordered) {
        classes.push("border");
    }

    return [
        ...classes,
        "w-full",
        "min-h-full",
        "bg-transparent",
        "relative",
        "table-auto",
        "table-fixed",
        "border",
        "bg-blue-500",
        "p-0",
    ];
};
